import React from 'react';
import { Typography, Paper, Stack, Chip } from '@mui/material';
import { SV } from '../../automation/stratovaiTestIds';
import {
  HEALTH_STATUS_LABELS,
  formatSignalValue,
  REQUIREMENT_ANALYSIS_COPY as C,
  hasMaterialFindings,
} from './requirementAnalysisUiConfig';

export default function RequirementAnalysisSummary({ data }) {
  const health = data?.requirement_health;
  const healthLabel = HEALTH_STATUS_LABELS[health?.status] || health?.status || '—';
  const signals = data?.signals || {};
  const counts = data?.finding_counts || {};

  return (
    <Paper variant="outlined" sx={{ p: 2 }} data-testid={SV.pk.requirementAnalysisSummary}>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        {C.summaryCardTitle}
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 1.5 }}>
        <Chip
          label={`${C.summaryRequirementHealthPrefix} ${healthLabel}`}
          color="primary"
          variant="outlined"
        />
        <Chip
          label={`${C.summaryClarityPrefix} ${formatSignalValue(signals.clarity)}`}
          size="small"
          variant="outlined"
        />
        <Chip
          label={`${C.summaryCompletenessPrefix} ${formatSignalValue(signals.completeness)}`}
          size="small"
          variant="outlined"
        />
        <Chip
          label={`${C.summaryAcPrefix} ${formatSignalValue(signals.acceptance_criteria)}`}
          size="small"
          variant="outlined"
        />
        <Chip
          label={`${C.summaryUserPerspectivePrefix} ${formatSignalValue(signals.user_perspective)}`}
          size="small"
          variant="outlined"
        />
        <Chip
          label={`${C.summaryVisualPrefix} ${formatSignalValue(signals.visual_consistency)}`}
          size="small"
          variant="outlined"
        />
      </Stack>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 1 }}>
        <Chip
          size="small"
          label={`${C.summaryBlockerPrefix} ${counts.blocker ?? 0}`}
          color="error"
          variant="outlined"
        />
        <Chip
          size="small"
          label={`${C.summaryImportantPrefix} ${counts.important ?? 0}`}
          color="warning"
          variant="outlined"
        />
        <Chip
          size="small"
          label={`${C.summaryOptionalPrefix} ${counts.optional ?? 0}`}
          variant="outlined"
        />
        <Chip
          size="small"
          label={`${C.summaryConfidencePrefix} ${data.confidence?.level || '—'}`}
          variant="outlined"
        />
      </Stack>
      {health?.reason ? (
        <Typography variant="body2" color="text.secondary">
          {health.reason}
        </Typography>
      ) : null}
      {data.confidence?.reason ? (
        <Typography variant="caption" display="block" sx={{ mt: 1 }} color="text.secondary">
          {C.confidenceReasonPrefix} {data.confidence.reason}
        </Typography>
      ) : null}
      {!hasMaterialFindings(data) ? (
        <Typography
          variant="body2"
          color="success.main"
          sx={{ mt: 1.5, fontWeight: 500 }}
          data-testid={SV.pk.requirementAnalysisNoFindingsQuiet}
        >
          {C.emptyNoFindings}
        </Typography>
      ) : null}
    </Paper>
  );
}
